// src/components/DietarySheet.js
// Dismissible bottom sheet for KioskPage / QRKioskPage / QRMallKioskPage.
import React, { useState } from 'react';
import DietaryTiles from './DietaryTiles';

export default function DietarySheet({ isAr, initial = 'none', onContinue, onSkip }) {
  const [pref, setPref] = useState(initial || 'none');

  return (
    <div style={{ position: 'fixed', inset: 0, zIndex: 3000, background: 'rgba(0,0,0,0.6)', display: 'flex', alignItems: 'flex-end', justifyContent: 'center' }}
      onClick={onSkip}>
      <div onClick={e => e.stopPropagation()} style={{
        width: '100%', maxWidth: 640, maxHeight: '92vh', overflowY: 'auto', boxSizing: 'border-box',
        background: 'var(--bg)', borderRadius: '22px 22px 0 0', padding: '20px 18px calc(20px + env(safe-area-inset-bottom, 0px))',
        borderTop: '1px solid var(--border)', direction: isAr ? 'rtl' : 'ltr',
      }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 12 }}>
          <div>
            <div style={{ fontSize: 22, fontWeight: 800, color: 'var(--text)' }}>
              {isAr ? 'هل لديك تفضيلات غذائية؟' : 'Any dietary preferences?'}
            </div>
            <div style={{ fontSize: 13, color: 'var(--text2)', margin: '4px 0 16px' }}>
              {isAr ? 'سنعرض لك الخيارات المناسبة' : "We'll highlight the right options for you"}
            </div>
          </div>
          <button type="button" onClick={onSkip} aria-label="Skip" style={{ background: 'none', border: 'none', color: 'var(--text3)', fontSize: 22, cursor: 'pointer' }}>✕</button>
        </div>

        <DietaryTiles value={pref} onChange={setPref} isAr={isAr} />

        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 14, marginTop: 18 }}>
          <button type="button" onClick={onSkip} style={{ background: 'none', border: 'none', color: 'var(--text2)', fontSize: 14, textDecoration: 'underline', cursor: 'pointer' }}>
            {isAr ? 'تخطي' : 'Skip'}
          </button>
          <button type="button" onClick={() => onContinue(pref)} style={{
            flex: 1, maxWidth: 260, padding: '14px 0', fontSize: 16, fontWeight: 800, borderRadius: 12,
            background: 'var(--accent)', color: 'var(--button-text)', border: 'none', cursor: 'pointer',
          }}>{isAr ? 'متابعة ←' : 'Continue →'}</button>
        </div>
      </div>
    </div>
  );
}
